import axios from 'axios';
import config from '../config';

export default {
    authenticate() {
        return axios.get(config.apiUri + '/users/me')
            .then(res => res.data)
            .catch(e => Promise.reject(e));
    }
}